export default class RuleGroupFilter {
  name: string;

  status: string;

  selectedRuleGroupOption: string;

  ruleGroupIds: Array<string>;

  constructor(obj: any = {}) {
    this.name = obj.name || '';
    this.status = obj.status || '';
    this.selectedRuleGroupOption = obj.selectedRuleGroupOption || '';
    this.ruleGroupIds = obj.ruleGroupIds || [];
  }

  public static of(obj: any = {}): RuleGroupFilter {
    return new RuleGroupFilter(obj);
  }
}
